import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import loginReducer from '../features/Login/loginSlice';
import homeSlice from '../features/home/homeSlice';
import organisationSlice from '../features/organisation/organisationSlice';
import userSlice from '../features/user/userSlice';
import dashboardSlice from '../features/dashboard/dashboardSlice';
import kpiSlice from '../features/kpi/kpiSlice';
import querySlice from '../features/query/querySlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    login: loginReducer,
    home: homeSlice,
    organisation: organisationSlice,
    user: userSlice,
    dashboard: dashboardSlice,
    query: querySlice,
    kpi: kpiSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
